export default __webpack_public_path__ + "static/media/navbar.3585d307.svg";